import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  AGENT_BUILDER_ROUTE,
  AUTH_SIGNIN_ROUTE,
  AUTH_SIGNUP_ROUTE,
  ORGANIZATION_BUILDER_ROUTE,
  UNIT_DETAILS_ROUTE,
} from '../shared/constants/routes';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(private router: Router) {}

  toAuthSignin(): void {
    this.router.navigate([AUTH_SIGNIN_ROUTE]);
  }

  toAuthSignup(): void {
    this.router.navigate([AUTH_SIGNUP_ROUTE]);
  }

  toAgentBuilder(): void {
    this.router.navigate([AGENT_BUILDER_ROUTE]);
  }

  toOrganizationBuilder(): void {
    this.router.navigate([ORGANIZATION_BUILDER_ROUTE]);
  }

  toUnitDetails(unit_id: string): void {
    this.router.navigate([`${UNIT_DETAILS_ROUTE}/${unit_id}`]);
  }
}
